"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWebFakeAPI = exports.createFakeAPI = exports.createWebTradeAPIWithApiKeyInfo = exports.createWebTradeAPI = exports.createTradeAPIWithKeyId = exports.createTradeAPI = exports.createExchangeApiAdapterWithKey = exports.TradeAPIImpl = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const AdapterFactory_1 = require("../../factory/AdapterFactory");
const FakeAPIAdapterImpl_1 = require("../TradingBot/FakeAPIAdapterImpl");
const TradeAPI_1 = require("./TradeAPI");
class TradeAPIImpl extends TradeAPI_1.TradeAPI {
    getInnerApiKeyInfo() {
        return this.apiAdapter.getInnerApiKeyInfo();
    }
    getRawSymbols() {
        return this.apiAdapter.getExchangeSymbols();
    }
    setExchangeSymbols(symbols) {
        this.apiAdapter.setExchangeSymbols(symbols);
    }
    getDefaultSymbols() {
        return this.apiAdapter.getDefaultSymbols().sort((a, b) => {
            return a.base.localeCompare(b.base);
        });
    }
    getSymbol(base, quote) {
        return this.apiAdapter.getSymbol(base, quote);
    }
    getSymbolInfoObservable(base, quote) {
        return this.apiAdapter.getSymbolInfoObservable(base, quote);
    }
    getTickerObservable(base, quote) {
        return this.apiAdapter.getTicker(base, quote);
    }
    queryTickerByRest(base, quote, market) {
        return this.apiAdapter.queryTickerByRest(base, quote, market);
    }
    getDepthDataObservable(base, quote) {
        return this.apiAdapter.getDepthData(base, quote);
    }
    getBalanceCurrencyPrice(coins, url) {
        return this.apiAdapter.getBalanceCurrencyPrice(coins, url);
    }
    createOrderObservable(orderParam, callback) {
        return this.apiAdapter.createOrder(orderParam);
    }
    cancelOrderObservable(orderData, info) {
        return this.apiAdapter.cancelOrder(orderData, info);
    }
    cancelAllOrderObservable(orderData) {
        return this.apiAdapter.cancelAllOrder(orderData);
    }
    queryCustomOrders(base, quote, queryOpen, orderId, limit, isManual) {
        return this.apiAdapter.queryCustomOrders(base, quote, queryOpen, orderId, limit, isManual);
    }
    getSpotOrder(symbol, id) {
        return this.apiAdapter.getSpotOrder(symbol, id);
    }
    refreshOrderRightNow() {
        return this.apiAdapter.refreshSubmittedOrderRightNow();
    }
    askTradePermission() {
        return this.apiAdapter.askTradePermission();
    }
    queryTradePermission() {
        return this.apiAdapter.queryTradePermission();
    }
    getQueryGridDescObservable(base, quote, griOrderId) {
        return this.apiAdapter.getQueryGridDescObservable(base, quote, griOrderId);
    }
    getQueryGridBasicInfoObservable(griOrderId, orderType) {
        return this.apiAdapter.getQueryGridBasicInfoObservable(griOrderId, orderType);
    }
    queryGridOrderBasicByIdWithRestApi(gridOrderId, orderType) {
        return this.apiAdapter.queryGridOrderBasicByIdWithRestApi(gridOrderId, orderType);
    }
    getQueryGridOpenOrdersObservable(gridOrderId, orderType, trend) {
        return this.apiAdapter.getQueryGridOpenOrdersObservable(gridOrderId, orderType, trend);
    }
    getQueryGridCloseOrdersObservable(gridOrderId, limit, orderType) {
        return this.apiAdapter.getQueryGridCloseOrdersObservable(gridOrderId, limit, orderType);
    }
    queryGridPairedCloseOrderList(orderId, orderType, pageToken, trend) {
        return this.apiAdapter.queryGridPairedCloseOrderList(orderId, orderType, pageToken, trend);
    }
    queryGridPairedCloseOrderListV2(params) {
        return this.apiAdapter.queryGridPairedCloseOrderListV2(params);
    }
    getQueryMarketAllBotOrders() {
        return this.apiAdapter.getQueryMarketAllBotOrders();
    }
    getQueryByStatusMarketBotOrders() {
        return this.apiAdapter.getQueryByStatusMarketBotOrders();
    }
    getWebSocketMarketBotOrders(exchange) {
        return this.apiAdapter.getWebSocketMarketBotOrders(exchange);
    }
    queryTickerWithSymbolList(symbolList) {
        return this.apiAdapter.queryTickerWithSymbolList(symbolList);
    }
    getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote) {
        return this.apiAdapter.getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote);
    }
    getQueryBotOrdersMoreV2(param) {
        return this.apiAdapter.getQueryBotOrdersMoreV2(param);
    }
    getMarketBotOrdersCountByStatus(params) {
        return this.apiAdapter.getMarketBotOrdersCountByStatus(params);
    }
    stopRefreshGridDetailInfo() {
        return this.apiAdapter.stopRefreshGridDetailInfo();
    }
    getTrades(base, quote) {
        return this.apiAdapter.getTrades(base, quote);
    }
    supportWebSocketDepth() {
        return this.apiAdapter.supportWebSocketDepth();
    }
    supportWebSocketTicker() {
        return this.apiAdapter.supportWebSocketTicker();
    }
    pauseWebSocket() {
        this.apiAdapter.pauseWebSocket();
    }
    checkMarketSupportOrderType(orderType) {
        return this.apiAdapter.checkMarketSupportOrderType(orderType);
    }
    unInitialized() {
        this.apiAdapter.unInitialized();
    }
    supportWebSocketOrder() {
        return this.apiAdapter.supportWebSocketOrder();
    }
    supportWebSocketTrades() {
        return this.apiAdapter.supportWebSocketTrades();
    }
    requestBotPoolData(orderType, exchange, base, quote) {
        return this.apiAdapter.requestBotPoolData(orderType, exchange, base, quote);
    }
    requestMyBotData(orderType, exchange, base, quote) {
        return this.apiAdapter.requestMyBotData(orderType, exchange, base, quote);
    }
    copyTradingBot(botId) {
        return this.apiAdapter.copyTradingBot(botId);
    }
    requestStrategyScores() {
        return this.apiAdapter.requestStrategyScores();
    }
    requestLoanRecords(bu_order_id, page, page_size) {
        return this.apiAdapter.requestLoanRecords(bu_order_id, page, page_size);
    }
    requestGridProPairsBearishRatio(base, quote) {
        return this.apiAdapter.requestGridProPairsBearishRatio(base, quote);
    }
    requestGridProfitData(type) {
        return this.apiAdapter.requestGridProfitData(type);
    }
    queryDeptAvaliable(coin) {
        return this.apiAdapter.queryDeptAvaliable(coin);
    }
    queryLeverageSupportedConfig() {
        return this.apiAdapter.queryLeverageSupportedConfig();
    }
    queryLeverageTradeInfo(base, quote) {
        return this.apiAdapter.queryLeverageTradeInfo(base, quote);
    }
    queryFutureFundingRate(base, quote, exchange) {
        return this.apiAdapter.queryFutureFundingRate(base, quote, exchange);
    }
    checkGridOrderCanCreate(request) {
        return this.apiAdapter.checkGridOrderCanCreate(request);
    }
    checkGridRequireBalance(bodyParam) {
        return this.apiAdapter.checkGridRequireBalance(bodyParam);
    }
    checkIGBalanceEnough(bodyParam) {
        return this.apiAdapter.checkIGBalanceEnough(bodyParam);
    }
    refreshTradingLimitInfoWithSymbol(base, quote) {
        return this.apiAdapter.refreshTradingLimitInfoWithSymbol(base, quote);
    }
    getTradingLimitForHuoBiPro(base, quote) {
        return this.apiAdapter.getTradingLimitForHuoBiPro(base, quote);
    }
    recoverGridOrder(orderId) {
        return this.apiAdapter.recoverGridOrder(orderId);
    }
    takeProfit(orderId) {
        return this.apiAdapter.takeProfit(orderId);
    }
    getMarketWSTickerObservable(market, symbolList) {
        return this.apiAdapter.getMarketWSTickerObservable(market, symbolList);
    }
    requireGridPervolume(bodyParam) {
        return this.apiAdapter.requireGridPervolume(bodyParam);
    }
    requireTopGridAIStrategy(market) {
        return this.apiAdapter.requireTopGridAIStrategy(market);
    }
    requireAIStrategyWithSymbol(market, base, quote) {
        return this.apiAdapter.requireAIStrategyWithSymbol(market, base, quote);
    }
    requireIGAIStrategy(market, base, quote) {
        return this.apiAdapter.requireIGAIStrategy(market, base, quote);
    }
    requireAITradePairWithMarket(market) {
        return this.apiAdapter.requireAITradePairWithMarket(market);
    }
    userDefineGridFeeRate(orderId, setToExchange, feeRate) {
        return this.apiAdapter.userDefineGridFeeRate(orderId, setToExchange, feeRate);
    }
    queryExchangeFeeRate(market, symbol) {
        return this.apiAdapter.queryExchangeFeeRate(market, symbol);
    }
    querySymbolTicker(base, quote) {
        return this.apiAdapter.querySymbolTicker(base, quote);
    }
    queryRestSymbolTicker(base, quote) {
        return this.apiAdapter.queryRestCCXTTicker(base, quote);
    }
    requireTopGridAIStrategyBatch(marketList) {
        return this.apiAdapter.requireTopGridAIStrategyBatch(marketList);
    }
    requireAITradePairDetailWithMarket(market) {
        return this.apiAdapter.requireAITradePairDetailWithMarket(market);
    }
    requireStableAIStrategyBatch(marketList) {
        return this.apiAdapter.requireStableAIStrategyBatch(marketList);
    }
    requireMainStreamAIStrategyBatch(marketList) {
        return this.apiAdapter.requireMainStreamAIStrategyBatch(marketList);
    }
    ///> 充提接口
    requestCoinAddress(coin) {
        return this.apiAdapter.requestCoinAddress(coin);
    }
    fetchDepositWithdrawHistory(coin, type, startTime) {
        return this.apiAdapter.fetchDepositWithdrawHistory(coin, type, startTime);
    }
    fetchDepositWithdrawHistoryV2(coin, type, startTime) {
        return this.apiAdapter.fetchDepositWithdrawHistoryV2(coin, type, startTime);
    }
    withdraw(param) {
        return this.apiAdapter.withdraw(param);
    }
    withdrawV2(param) {
        return this.apiAdapter.withdrawV2(param);
    }
    cancelWithdraw(id) {
        return this.apiAdapter.cancelWithdraw(id);
    }
    requestAllBrokerCoins() {
        return this.apiAdapter.requestAllBrokerCoins();
    }
    requestAllBrokerCoinsV2() {
        return this.apiAdapter.requestAllBrokerCoinsV2();
    }
    parseProtocolToDisplay(coinName, protocol) {
        return this.apiAdapter.parseProtocolToDisplay(coinName, protocol);
    }
    fetchVerifyCode(verifyCodeType) {
        return this.apiAdapter.fetchVerifyCode(verifyCodeType);
    }
    queryCustomOrderPage(queryParam, queryOpen, repeat) {
        return this.apiAdapter.queryCustomOrderPage(queryParam, queryOpen, repeat);
    }
    queryAIPOrTWAPCustomOrdersOnce(orderId, pgno = 0, pgnm = 10) {
        return this.apiAdapter.queryAIPOrTWAPCustomOrdersOnce(orderId, pgno, pgnm);
    }
    queryDCACustomOrders(orderId, pageToken) {
        return this.apiAdapter.queryDCACustomOrders(orderId, pageToken);
    }
    getBotTypeBalance() {
        return this.apiAdapter.getBotTypeBalance();
    }
    getQueryAllMarketBotOrdersMoreV2(param, allExchange) {
        return this.apiAdapter.getQueryAllMarketBotOrdersMoreV2(param, allExchange);
    }
    requestMoveRecords(coin) {
        return this.apiAdapter.requestMoveRecords(coin);
    }
    queryGridProBalanceSequence(orderType, orderId, period) {
        return this.apiAdapter.queryGridProBalanceSequence(orderType, orderId, period);
    }
    /**
     * enhanceAip 收益
     * @param orderType
     * @param orderId
     */
    queryGridProBalanceSequenceV2(orderType, orderId) {
        return this.apiAdapter.queryGridProBalanceSequenceV2(orderType, orderId);
    }
    queryPionexFeeRate(base, quote) {
        return this.apiAdapter.queryPionexFeeRate(base, quote);
    }
    transferMargin(orderType, orderId, param) {
        return this.apiAdapter.transferMargin(orderType, orderId, param);
    }
    queryTradeLimit(minPrice, maxPrice, symbol) {
        return this.apiAdapter.queryTradeLimit(minPrice, maxPrice, symbol);
    }
    queryAipBackTest(base, quote, exchange) {
        return this.apiAdapter.queryAipBackTest(base, quote, exchange);
    }
    queryAipLimit(symbol, exchange) {
        return this.apiAdapter.queryAipLimit(symbol, exchange);
    }
    requestBinanceLeverageConfigures(exchange) {
        return this.apiAdapter.requestBinanceLeverageConfigures(exchange);
    }
    requestSwapFee() {
        return this.apiAdapter.requestSwapFee();
    }
    queryTransferRecord(orderType, orderId, transfer_type) {
        return this.apiAdapter.queryTransferRecord(orderType, orderId, transfer_type);
    }
    queryTransferRecordV2(params) {
        return this.apiAdapter.queryTransferRecordV2(params);
    }
    /**
     * 查询Transfer 记录,包含分页信息, 特指保证金变更记录，主要是服务端接口不一致
     * @param params
     */
    queryTransferRecordV3(params) {
        return this.apiAdapter.queryTransferRecordV3(params);
    }
    /**
     * 合约追踪平仓
     * @param params
     */
    futuresSmartTradeClosePosition(params) {
        return this.apiAdapter.futuresSmartTradeClosePosition(params);
    }
    /**
     * 修改追踪参数
     * @param params
     */
    modifyFSTOrderTPSL(params) {
        return this.apiAdapter.modifyFSTOrderTPSL(params);
    }
    transferProfit(orderType, orderId, param) {
        return this.apiAdapter.transferProfit(orderType, orderId, param);
    }
    hedgeGridTransferProfit(orderId, param) {
        return this.apiAdapter.hedgeGridTransferProfit(orderId, param);
    }
    queryCurrentDayProfitAndLoss() {
        return this.apiAdapter.queryCurrentDayProfitAndLoss();
    }
    changeOrderTriggerPrices(params) {
        return this.apiAdapter.changeOrderTriggerPrices(params);
    }
    querySLProOrderList(params) {
        return this.apiAdapter.querySLProOrderList(params);
    }
    queryBotExchangeCloseOrderList(orderId, orderType, tag) {
        return this.apiAdapter.queryBotExchangeCloseOrderList(orderId, orderType, tag);
    }
    getQueryAllMarketBotOrdersMoreV3(params) {
        return this.apiAdapter.getQueryAllMarketBotOrdersMoreV3(params);
    }
    queryAllBotOrdersV4(params) {
        return this.apiAdapter.queryAllBotOrdersV4(params);
    }
    fetchFutureSymbolBalance(symbol) {
        return this.apiAdapter.fetchFutureSymbolBalance(symbol);
    }
    fetchFutureSpotFundingFeeRate() {
        return this.apiAdapter.fetchFutureSpotFundingFeeRate();
    }
    fetchCoinMarginedFundingFeeRate() {
        return this.apiAdapter.fetchCoinMarginedFundingFeeRate();
    }
    fetchFutureSpotIncome(orderId, nexPageToken) {
        return this.apiAdapter.fetchFutureSpotIncome(orderId, nexPageToken);
    }
    fetchOrderIncomes(orderId, orderType, nexPageToken, incomeTypeIn) {
        return this.apiAdapter.fetchOrderIncomes(orderId, orderType, nexPageToken, incomeTypeIn);
    }
    interruptFsaAdjustPosition(orderType, orderId) {
        return this.apiAdapter.interruptFsaAdjustPosition(orderType, orderId);
    }
    hedgeGridCloseOrder(params) {
        return this.apiAdapter.hedgeGridCloseOrder(params);
    }
    getSpotAndFundTodayInitAsset() {
        return this.apiAdapter.getSpotAndFundTodayInitAsset();
    }
    fetchPionexStrategyBalance(strategyId) {
        return this.apiAdapter.fetchPionexStrategyBalance(strategyId);
    }
    convertStableCoin(source, target, sourceAmount) {
        return this.apiAdapter.convertStableCoin(source, target, sourceAmount);
    }
    querySymbolStatus(symbol) {
        return this.apiAdapter.querySymbolStatus(symbol);
    }
    fsaRiskPlanStatus() {
        return this.apiAdapter.fsaRiskPlanStatus();
    }
    joinFSARiskPlan() {
        return this.apiAdapter.joinFSARiskPlan();
    }
    queryCoinTransferInfo() {
        return this.apiAdapter.queryCoinTransferInfo();
    }
    querySROrderRecords(param) {
        return this.apiAdapter.querySROrderRecords(param);
    }
    querySymbolsStatus() {
        return this.apiAdapter.querySymbolsStatus();
    }
    queryManualOrders(param) {
        return this.apiAdapter.queryManualOrders(param);
    }
    queryBotOrderCount() {
        return this.apiAdapter.queryBotOrderCount();
    }
    getAllReleaseProfit() {
        return this.apiAdapter.getAllReleaseProfit();
    }
    modifySRBotName(name, orderType, orderId) {
        return this.apiAdapter.modifySRBotName(name, orderType, orderId);
    }
    modifySRRules(param, orderType, orderId) {
        return this.apiAdapter.modifySRRules(param, orderType, orderId);
    }
    smartRebalanceUpdatePortfolio(orderId, portfolio, allocateOut) {
        return this.apiAdapter.smartRebalanceUpdatePortfolio(orderId, portfolio, !!allocateOut);
    }
    querySRModifyCoinRecord(orderId) {
        return this.apiAdapter.querySRModifyCoinRecord(orderId);
    }
    allocateSRSmallBalance(orderId) {
        return this.apiAdapter.allocateSRSmallBalance(orderId);
    }
    /**
     * 查询查询策略可用的信号
     */
    querySignalList(orderType, base, quote, signal_type) {
        return this.apiAdapter.querySignalList(orderType, base, quote, signal_type);
    }
    /**
     * 查询策略可用的信号
     */
    queryMultiCoinsSignalList(orderType, symbols, filter_option_all_symbols, signal_type) {
        return this.apiAdapter.queryMultiCoinsSignalList(orderType, symbols, filter_option_all_symbols, signal_type);
    }
    /**
     * 查询信号详情
     * @param signal_type
     */
    querySignalDetail(signal_type) {
        return this.apiAdapter.querySignalDetail(signal_type);
    }
    /**
     * 查询存币生息支持的币种
     * @param coin
     */
    queryFMCoins(coin) {
        return this.apiAdapter.queryFMCoins(coin);
    }
    /**
     * 存币生息申购
     * @param param
     */
    investFMCoin(param) {
        return this.apiAdapter.investFMCoin(param);
    }
    /**
     * 查询单笔申购
     * @param recordId
     */
    queryFMCoinInvest(recordId) {
        return this.apiAdapter.queryFMCoinInvest(recordId);
    }
    /**
     * 存币生息赎回
     * @param param
     */
    redeemFMCoin(param) {
        return this.apiAdapter.redeemFMCoin(param);
    }
    /**
     * 查询单笔赎回
     * @param recordId
     */
    queryFMCoinRedeem(recordId) {
        return this.apiAdapter.queryFMCoinRedeem(recordId);
    }
    /**
     * 查询申赎记录
     * @param param
     */
    queryFMTransactions(param) {
        return this.apiAdapter.queryFMTransactions(param);
    }
    /**
     * 查询存币生息持仓
     */
    queryFMPositions() {
        return this.apiAdapter.queryFMPositions();
    }
    /**
     * 存币生息提取利息
     * @param param
     */
    releaseFMInterest(param) {
        return this.apiAdapter.releaseFMInterest(param);
    }
    /**
     * 查询存币生息利息记录
     * @param param
     */
    queryFMInterestRecord(param) {
        return this.apiAdapter.queryFMInterestRecord(param);
    }
    /**
     * 查询利息总览
     */
    queryFMInterestAggregate() {
        return this.apiAdapter.queryFMInterestAggregate();
    }
    /**
     * 查询MTG 当前挂单
     * @param orderId
     */
    queryMTGCurrentRound(orderId) {
        return this.apiAdapter.queryMTGCurrentRound(orderId);
    }
    /**
     * 查询多币MTG 当前挂单
     * @param orderId
     */
    queryMTGMultiModeCurrentRounds(orderId) {
        return this.apiAdapter.queryMTGMultiModeCurrentRounds(orderId);
    }
    /**
     * 查询MTG 历史挂单
     * @param param
     */
    queryMTGRoundList(param) {
        return this.apiAdapter.queryMTGRoundList(param);
    }
    /**
     * 根据id 查询order
     * @param orderId
     */
    queryBotOrderInfo(orderId) {
        return this.apiAdapter.queryBotOrderInfo(orderId);
    }
    patchFSAAutoSettle(autoSettle, orderId) {
        return this.apiAdapter.patchFSAAutoSettle(autoSettle, orderId);
    }
    configureMartingaleStopPriceRange(orderId, base, range) {
        return this.apiAdapter.configureMartingaleStopPriceRange(orderId, base, range);
    }
    setMartingaleStopPrice(orderId, base, modifyPriceType, modifyValue) {
        return this.apiAdapter.setMartingaleStopPrice(orderId, base, modifyPriceType, modifyValue);
    }
    requestMTGAIStrategyWithSymbol(base, quote) {
        return this.apiAdapter.requestMTGAIStrategyWithSymbol(base, quote);
    }
    /**
     * 多币马丁AI参数
     * @param pairs
     */
    requestMTGMultiAIStrategyWithSymbols(pairs) {
        return this.apiAdapter.requestMTGMultiAIStrategyWithSymbols(pairs);
    }
    /**
     * 多币马丁最小投资额
     * @param param
     */
    queryMTGMultiMinInvest(param) {
        return this.apiAdapter.queryMTGMultiMinInvest(param);
    }
    renewMartingale(orderId, base) {
        return this.apiAdapter.renewMartingale(orderId, base);
    }
    modifyBotOrderNote(orderId, note, orderType) {
        return this.apiAdapter.modifyBotOrderNote(orderId, note, orderType);
    }
    modifySRPriceInfo(param, orderId) {
        return this.apiAdapter.modifySRPriceInfo(param, orderId);
    }
    editStopRatio(data, orderId) {
        return this.apiAdapter.editStopRatio(data, orderId);
    }
    idleFunds(orderId, orderType) {
        return this.apiAdapter.idleFunds(orderId, orderType);
    }
    /**
     * 查询闲置资金
     * @param orderId
     * @param orderType
     */
    queryIdleFunds(orderId, orderType) {
        return this.apiAdapter.queryIdleFunds(orderId, orderType);
    }
    setGridPause(orderId, orderType, data) {
        return this.apiAdapter.setGridPause(orderId, orderType, data);
    }
    setGridResume(orderId, orderType) {
        return this.apiAdapter.setGridResume(orderId, orderType);
    }
    /**
     * 收藏订单参数的增, 删, 查
     */
    saveOrderFavParams(type, title, data) {
        return this.apiAdapter.saveOrderFavParams(type, title, data);
    }
    deleteOrderFavParams(id, type) {
        return this.apiAdapter.deleteOrderFavParams(id, type);
    }
    orderFavParamsList(type) {
        return this.apiAdapter.orderFavParamsList(type);
    }
    queryGridMinAddPosition(param, orderType) {
        return this.apiAdapter.queryGridMinAddPosition(param, orderType);
    }
    queryGridPositionRecordList(orderId, orderType) {
        return this.apiAdapter.queryGridPositionRecordList(orderId, orderType);
    }
    /* 获取网格订单仓位变更记录支持分页
     * @param param
     */
    queryGridPositionRecordListV2(param) {
        return this.apiAdapter.queryGridPositionRecordListV2(param);
    }
    queryGridReinvestList(param) {
        return this.apiAdapter.queryGridReinvestList(param);
    }
    switchProfitAutoReinvest(param) {
        return this.apiAdapter.switchProfitAutoReinvest(param);
    }
    queryOrderShareID(orderId) {
        return this.apiAdapter.queryOrderShareID(orderId);
    }
    queryOrderShare(shareId) {
        return this.apiAdapter.queryOrderShare(shareId);
    }
    gridAdjustParams(param) {
        return this.apiAdapter.gridAdjustParams(param);
    }
    /**
     * gridv4网格订单修改参数
     * @param param
     */
    gridV4AdjustParams(param) {
        return this.apiAdapter.gridV4AdjustParams(param);
    }
    queryVolatilityRank(param) {
        return this.apiAdapter.queryVolatilityRank(param);
    }
    /**
     * 查询KOL策略列表
     * @param lang
     * @param page_token
     * @param condition
     * @param category
     * @param enable_all_period
     * @param authorize
     */
    queryKolStrategy(lang, page_token, condition, category, enable_all_period, authorize) {
        return this.apiAdapter.queryKolStrategy(lang, page_token, condition, category, enable_all_period, authorize);
    }
    /**
     * 查询KOL策略信号列表
     * @param strategyId
     * @param page_token
     */
    queryKolStrategySignals(strategyId, page_token) {
        return this.apiAdapter.queryKolStrategySignals(strategyId, page_token);
    }
    /**
     * 查询KOL策略历史信号列表
     * @param strategyId
     * @param symbol
     */
    queryKolStrategyHistorySignals(strategyId, symbol, lang) {
        return this.apiAdapter.queryKolStrategyHistorySignals(strategyId, symbol, lang);
    }
    /**
     * 查询KOL策略信号详情
     * @param strategyId
     * @param lang
     * @param enable_all_period
     */
    queryKolStrategyDetail(strategyId, lang, enable_all_period) {
        return this.apiAdapter.queryKolStrategyDetail(strategyId, lang, enable_all_period);
    }
    /**
     * 修改KOL信号通知 下面参数二选一
     * @param strategyId
     * @param signalId
     * @param bu_order_id
     * @param bu_order_type
     */
    updateStrategySignals(strategyId, signalId, bu_order_id, bu_order_type) {
        return this.apiAdapter.updateStrategySignals(strategyId, signalId, bu_order_id, bu_order_type);
    }
    /**
     * 订阅kol信号
     * @param strategyId
     * @param symbol
     */
    subscribeStrategySignals(strategyId, symbol) {
        return this.apiAdapter.subscribeStrategySignals(strategyId, symbol);
    }
    /**
     * 取消订阅kol信号
     * @param strategyId
     */
    unsubscribeStrategySignals(strategyId) {
        return this.apiAdapter.unsubscribeStrategySignals(strategyId);
    }
    /**
     *  更新kol 信号订阅币对
     * @param strategyId
     * @param symbol
     */
    updateSubscribeStrategySignals(strategyId, symbol) {
        return this.apiAdapter.updateSubscribeStrategySignals(strategyId, symbol);
    }
    /**
     * 获取策略信号收益表现图表详情
     * @param strategyId
     * @param period
     */
    queryStrategyPerformance(strategyId, period) {
        return this.apiAdapter.queryStrategyPerformance(strategyId, period);
    }
    /**
     * 查询订阅信号详情
     * @param strategyId
     */
    queryStrategySubscriptionInfo(strategyId) {
        return this.apiAdapter.queryStrategySubscriptionInfo(strategyId);
    }
    /**
     * 查询特定的信号
     * @param strategyId
     * @param params
     */
    queryStrategySignal(strategyId, params) {
        return this.apiAdapter.queryStrategySignal(strategyId, params);
    }
    /**
     * 通过信号id查询定的信号
     * @param strategyId
     * @param signalId
     */
    queryStrategySignalById(strategyId, signalId) {
        return this.apiAdapter.queryStrategySignalById(strategyId, signalId);
    }
    /**
     * 查询策略跟单历史交易记录
     * @param params
     */
    querySmartCopyRounds(params) {
        return this.apiAdapter.querySmartCopyRounds(params);
    }
    /**
     * 修改策略跟单是否开启复利
     * @param params
     */
    modifySmartCopyCompound(params) {
        return this.apiAdapter.modifySmartCopyCompound(params);
    }
    /**
     * 策略跟单 手动平仓
     */
    manuallyLiquidateSCPosition(params) {
        return this.apiAdapter.manuallyLiquidateSCPosition(params);
    }
    /**
     * 修改网格的移动网格配置
     * @param params
     * @param orderId
     * @param orderType
     */
    modifyGridMovingOption(params, orderId, orderType) {
        return this.apiAdapter.modifyGridMovingOption(params, orderId, orderType);
    }
    /**
     * 获取最大单网格买入量
     * @param params
     * @param orderType
     */
    queryGridMaxPerVolume(params, orderType) {
        return this.apiAdapter.queryGridMaxPerVolume(params, orderType);
    }
    /**
     * 获取AI策略列表
     * @param params
     */
    queryGridV4AiStrategyList(params) {
        return this.apiAdapter.queryGridV4AiStrategyList(params);
    }
    queryGridV5AiStrategyList(params) {
        return this.apiAdapter.queryGridV5AiStrategyList(params);
    }
    /**
     修改机器人 订单名称
     * @param name
     * @param orderType
     * @param orderId
     */
    modifyOrderBotName(name, orderType, orderId) {
        return this.apiAdapter.modifyOrderBotName(name, orderType, orderId);
    }
    /**
     * 修改策略跟单止盈止损比例
     * @param param
     * @param orderId
     * @returns
     */
    modifySCStopRatio(param, orderId) {
        return this.apiAdapter.modifySCStopRatio(param, orderId);
    }
    /**
     * 订单分组创建
     * @param params
     */
    createOrderGroup(params) {
        return this.apiAdapter.createOrderGroup(params);
    }
    /**
     * 订单分组修改绑定数组
     * @param params
     * @constructor
     */
    OrderGroupBindOrder(params) {
        return this.apiAdapter.OrderGroupBindOrder(params);
    }
    /**
     * 订单分组解绑
     * @param group_id
     * @constructor
     */
    OrderGroupUnBindOrder(group_id) {
        return this.apiAdapter.OrderGroupUnBindOrder(group_id);
    }
    /**
     * 支持订单分组的bot订单列表
     * @param params
     */
    queryAllBotOrdersV5(params) {
        return this.apiAdapter.queryAllBotOrdersV5(params);
    }
    /**
     * 根据分组id查询分组内部订单列表
     * @param group_id
     * @param page_token
     */
    queryGroupOrderList(group_id, page_token) {
        return this.apiAdapter.queryGroupOrderList(group_id, page_token);
    }
    /**
     * 根据分组id查询分组详情
     * @param group_id
     */
    queryGroupOrderDetail(group_id) {
        return this.apiAdapter.queryGroupOrderDetail(group_id);
    }
    /**
     * 仅通过通过id和type,取消订单
     * @param orderId
     * @param orderType
     * @param info
     */
    cancelOrderObservableById(orderId, orderType, info) {
        return this.apiAdapter.cancelOrderObservableById(orderId, orderType, info);
    }
    /**
     * 查询bot策略单数量
     */
    queryBotOrderCountV2() {
        return this.apiAdapter.queryBotOrderCountV2();
    }
    /**
     * 订单分组重命名
     * @param params
     */
    OrderGroupRenameOrder(params) {
        return this.apiAdapter.OrderGroupRenameOrder(params);
    }
    /**
     * 获取可用额度
     * @param params
     */
    queryFSTMaxLimit(params) {
        return this.apiAdapter.queryFSTMaxLimit(params);
    }
    /**
     * 修改触发价/止盈止损
     * @param params
     */
    editTriggerPrice(orderId, params) {
        return this.apiAdapter.editTriggerPrice(orderId, params);
    }
    /**
     * 立即触发
     * @param params
     */
    orderImmediateTrigger(orderId, params) {
        return this.apiAdapter.orderImmediateTrigger(orderId, params);
    }
    queryGridOverview(params) {
        return this.apiAdapter.queryGridOverview(params);
    }
    queryEnhancedAipAdjustRecord(params) {
        return this.apiAdapter.queryEnhancedAipAdjustRecord(params);
    }
    adjustEnhancedAipParams(params) {
        return this.apiAdapter.adjustEnhancedAipParams(params);
    }
    setGridCloseSellModel(params) {
        return this.apiAdapter.setGridCloseSellModel(params);
    }
    /**
     * @description: 获取可用订单数量额度 https://pionex.atlassian.net/wiki/spaces/backend/pages/50731121/smart+copy+API#%E8%8E%B7%E5%8F%96%E5%8F%AF%E7%94%A8%E8%AE%A2%E5%8D%95%E6%95%B0%E9%87%8F%E9%A2%9D%E5%BA%A6
     * @return {*}
     */
    fetchSmartCopyCheck() {
        return this.apiAdapter.fetchSmartCopyCheck();
    }
    fetchOrderNotificationList(params) {
        return this.apiAdapter.fetchOrderNotificationList(params);
    }
}
exports.TradeAPIImpl = TradeAPIImpl;
function createExchangeApiAdapterWithKey(apiKey, forceLocalLogic) {
    return (0, AdapterFactory_1.instanceApiAdapterWithKey)(apiKey, forceLocalLogic);
}
exports.createExchangeApiAdapterWithKey = createExchangeApiAdapterWithKey;
function _getExchangeApiKeyInfoWithMarket(market, apikey, secret, extra, token, cloudKeyId, isCN) {
    if (apikey) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getApiKeyCloudId(apikey)
            .pipe((0, operators_1.map)((keyId) => {
            return {
                key: apikey,
                secret: secret,
                extra: extra,
                market: market,
                cloudKeyId: keyId,
                isCN: isCN,
                swapCloudKeyId: "",
            };
        }));
    }
    else {
        return (0, rxjs_1.of)({
            key: apikey,
            secret: secret,
            extra: extra,
            market: market,
            cloudKeyId: cloudKeyId,
            isCN: isCN,
            swapCloudKeyId: "",
        });
    }
}
/**
 * 初始化接口时保证必要的参数
 * 创建访问库的实例接口
 * @param market            市场名
 * @param apikey            key
 * @param secret            secret
 * @param extra             extra
 */
function createTradeAPI(market, apikey, secret, extra) {
    return _getExchangeApiKeyInfoWithMarket(market, apikey, secret, extra, "", "", (0, trade_utils_lib_1.getTradeDependencyInstance)().getIsChina()).pipe((0, operators_1.map)((paramResult) => {
        return new TradeAPIImpl(createExchangeApiAdapterWithKey(paramResult), market);
    }));
}
exports.createTradeAPI = createTradeAPI;
function createTradeAPIWithKeyId(market, keyId) {
    return new TradeAPIImpl(createExchangeApiAdapterWithKey({
        key: keyId,
        secret: "",
        extra: "",
        market: market,
        cloudKeyId: keyId,
    }), market);
}
exports.createTradeAPIWithKeyId = createTradeAPIWithKeyId;
/**
 * 获取web端调用的接口
 * @param market
 * @param cloudKeyId
 */
function createWebTradeAPI(market, cloudKeyId) {
    return (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .getAccessToken()
        .pipe((0, operators_1.catchError)((err) => {
        return (0, rxjs_1.of)("");
    }))
        .pipe((0, operators_1.map)((token) => {
        return new TradeAPIImpl(createExchangeApiAdapterWithKey({
            key: "",
            secret: "",
            extra: "",
            market: market,
            cloudKeyId: cloudKeyId,
            isCN: (0, trade_utils_lib_1.getTradeDependencyInstance)().getIsChina(),
            source: "web",
        }), market);
    }));
}
exports.createWebTradeAPI = createWebTradeAPI;
/**
 * 获取web端调用的接口
 */
function createWebTradeAPIWithApiKeyInfo(apiKeyInfo) {
    return (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .getAccessToken()
        .pipe((0, operators_1.catchError)((err) => {
        return (0, rxjs_1.of)("");
    }))
        .pipe((0, operators_1.map)((token) => {
        return new TradeAPIImpl(createExchangeApiAdapterWithKey({
            key: "",
            secret: "",
            extra: "",
            market: apiKeyInfo.exchange,
            cloudKeyId: apiKeyInfo.key_id,
            isCN: (0, trade_utils_lib_1.getTradeDependencyInstance)().getIsChina(),
            source: "web",
        }), apiKeyInfo.exchange);
    }));
}
exports.createWebTradeAPIWithApiKeyInfo = createWebTradeAPIWithApiKeyInfo;
function createFakeAPI(market) {
    let apiKey = {
        key: "fake",
        secret: "fake",
        extra: "",
        market: market,
        cloudKeyId: "",
    };
    return new TradeAPIImpl((0, FakeAPIAdapterImpl_1.getFakeAdapter)(apiKey), market);
}
exports.createFakeAPI = createFakeAPI;
function createWebFakeAPI(market, key, secretKey, extra) {
    let apiKey = {
        key: key,
        secret: secretKey,
        extra: extra,
        market: market,
        cloudKeyId: "",
        source: "web",
    };
    return new TradeAPIImpl((0, FakeAPIAdapterImpl_1.getFakeAdapter)(apiKey), market);
}
exports.createWebFakeAPI = createWebFakeAPI;
